<div class="card">
    <div class="card-body">
        <ngx-spinner name="dialogSpinner" [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium">
            <p style="color: white">Loading ...</p>
        </ngx-spinner>        
        <div class="row">
            <div class="col-md-12">
                <h3>Amazon audience parameters</h3>
                <section>
                    <mat-button-toggle-group [(ngModel)]="newAudience" name="newAudienceSelector" aria-label="New audience" (change)="onNewAudienceSelected()">
                        <mat-button-toggle value="0">Existing audience</mat-button-toggle>
                        <mat-button-toggle value="1">New audience</mat-button-toggle>
                    </mat-button-toggle-group>        
                </section>
            </div>
        </div>
        <div class="row">&nbsp;</div>
        <form [formGroup]="form">
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Profile</mat-label>
                        <input #matAutocompleteProfiles name="matAutocompleteProfiles" type="text" placeholder="Pick one" aria-label="Profile" matInput 
                            [formControl]="form.controls.profileId" [matAutocomplete]="auto" 
                            (input)="filterProfiles()" (focus)="filterProfiles()" (click)="resetProfilesFilter()">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [panelWidth]="'500px'" [displayWith]="getProfileDescription.bind(this)" (optionSelected)="onProfileChange($event)">
                            <mat-option *ngFor="let profile of filteredProfiles" [value]="profile.profileId">{{ profile.profileId }} - {{ profile.accountInfo?.name }}</mat-option>
                        </mat-autocomplete>                    
                        <mat-error *ngIf="form.controls.profileId.errors && (form.controls.profileId.dirty || form.controls.profileId.touched)">Profile is required</mat-error>
                    </mat-form-field>   
                </div>
                <div class="col-md-3">
                    <mat-form-field *ngIf="advertisers.length > 0" style="width: 100%;">
                        <mat-label>Advertiser</mat-label>
                        <input #matAutocompleteAdvertisers name="matAutocompleteAdvertisers" type="text" placeholder="Pick one" aria-label="Audience" matInput 
                        [formControl]="form.controls.advertiserId" [matAutocomplete]="auto"
                        (input)="filterAdvertisers()" (focus)="filterAdvertisers()" (click)="resetAdvertisersFilter()">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [panelWidth]="'500px'" [displayWith]="getAdvertiserDescription.bind(this)" (optionSelected)="onAdvertiserChange($event)">
                            <mat-option *ngFor="let advertiser of filteredAdvertisers" [value]="advertiser.advertiserId">{{ advertiser.advertiserId }} - {{ advertiser.name }}</mat-option>
                        </mat-autocomplete>                    
                        <mat-error *ngIf="form.controls.advertiserId.errors && (form.controls.advertiserId.dirty || form.controls.advertiserId.touched)">Advertiser is required</mat-error>
                    </mat-form-field>   
                </div>
                <div class="col-md-3" *ngIf="newAudience == '0'">
                    <mat-form-field *ngIf="!!form.controls.advertiserId.value && audiences.length > 0" style="width: 100%;">
                        <mat-label>Audience</mat-label>
                        <input #matAutocompleteAudiences name="matAutocompleteAudiences" type="text" placeholder="Pick one" aria-label="Audience" matInput 
                        [formControl]="form.controls.audienceId" [matAutocomplete]="auto"
                        (input)="filterAudiences()" (focus)="filterAudiences()" (click)="resetAudiencesFilter()"
                        style="width: 100%;">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [panelWidth]="'500px'" [displayWith]="getAudienceDescription.bind(this)" (optionSelected)="onAudienceChange($event)">
                            <mat-option *ngFor="let audience of filteredAudiences" [value]="audience.audienceId">{{audience.audienceId}} - {{audience.audienceName}}</mat-option>
                        </mat-autocomplete>                      
                        <mat-error *ngIf="form.controls.audienceId.errors && (form.controls.audienceId.dirty || form.controls.audienceId.touched)">Audience is required</mat-error>                        
                    </mat-form-field>   
                    <mat-error *ngIf="!!form.controls.advertiserId.value && audiences.length == 0" style="width: 100%;">The advertiser has no AMC audiences</mat-error>
                </div>
                <div class="col-md-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Dataset Name</mat-label>
                        <input
                            name="datasetName"
                            type="text"
                            placeholder="Dataset name"
                            aria-label="Dataset Name"
                            matInput
                            maxlength="100"
                            [formControl]="form.controls.datasetName"
                            style="width: 100%;">
                        <mat-hint>
                            Must start with a letter. Only letters, numbers, "_" and "-" are allowed. Maximum 100 characters.
                        </mat-hint>
                        <mat-error
                            *ngIf="form.controls.datasetName.hasError('required')
                                && (form.controls.datasetName.dirty || form.controls.datasetName.touched)">
                            Dataset Name is required
                        </mat-error>
                        <mat-error
                            *ngIf="form.controls.datasetName.hasError('minlength')
                                && (form.controls.datasetName.dirty || form.controls.datasetName.touched)">
                            Dataset Name must have at least 10 characters
                        </mat-error>
                        <mat-error
                            *ngIf="form.controls.datasetName.hasError('maxlength')
                                && (form.controls.datasetName.dirty || form.controls.datasetName.touched)">
                            Dataset Name cannot exceed 100 characters
                        </mat-error>
                        <mat-error
                            *ngIf="form.controls.datasetName.hasError('pattern')
                                && (form.controls.datasetName.dirty || form.controls.datasetName.touched)">
                            Dataset Name must start with a letter and can only contain letters, numbers, "_" and "-"
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>      
        </form>
    </div>
</div>
